import { useState } from "react";
import { Parser } from "expr-eval";

/* -------------------------------------------------
   🔢  SIMPLE CALCULATOR (safe version with expr-eval)
------------------------------------------------- */
export default function Calculator({ onClose }) {
  const [display, setDisplay] = useState("");

  const handleEquals = () => {
    try {
      // 用 expr-eval 解析
      const parser = new Parser();
      // expr-eval 不支援 2++2, "3+-2" 這種語法錯誤會自動丟 error
      setDisplay(String(parser.evaluate(display)));
    } catch {
      setDisplay("Error");
    }
  };

  const handleInput = (c) =>
    setDisplay((d) => (d === "Error" ? c : d + c));

  return (
    <div className="calculator-container">
      <div className="calculator-display">{display || "0"}</div>
      {["789/", "456*", "123-", "0C=+","."].map((row, i) => (
        <div className="calculator-row" key={i}>
          {row.split("").map((ch) =>
            ch === "C" ? (
              <button key={ch} onClick={() => setDisplay("")}>
                C
              </button>
            ) : ch === "=" ? (
              <button key={ch} onClick={handleEquals}>
                =
              </button>
            ) : (
              <button key={ch} onClick={() => handleInput(ch)}>
                {ch}
              </button>
            )
          )}
        </div>
      ))}
      <button className="calculator-close" onClick={onClose}>
        Close Calculator
      </button>
    </div>
  );
}
